import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/ask';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 px-6 flex justify-center">
      <div className="w-full max-w-sm">
        <h1 className="font-serif text-2xl text-warm text-center mb-2">Welcome Back</h1>
        <p className="text-warm-100/50 text-sm text-center mb-8">Sign in to continue your journey</p>

        {error && (
          <div className="bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-3 mb-6 text-red-400 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-warm-100/60 text-xs mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="w-full bg-dark-100 border border-dark-200/50 rounded-lg px-4 py-3 text-warm text-sm focus:outline-none focus:border-gold/30 placeholder-warm-100/30"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-warm-100/60 text-xs mb-1.5">Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              minLength={8}
              className="w-full bg-dark-100 border border-dark-200/50 rounded-lg px-4 py-3 text-warm text-sm focus:outline-none focus:border-gold/30 placeholder-warm-100/30"
              placeholder="Min 8 characters"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gold/15 border border-gold/30 text-gold py-3 rounded-lg text-sm hover:bg-gold/25 transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-warm-100/40 text-sm text-center mt-6">
          Don't have an account?{' '}
          <Link to="/register" state={{ from }} className="text-gold hover:text-gold-light transition-colors">
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}
